// @ts-nocheck
import ManageYourPlan from '@/ui/pages/subscription/Chargebee/details/ManageYourPlan.vue';
import { h, defineComponent, onMounted, ref } from 'vue';
import { container, loader, pageTitle } from '@/ui/components';
import { PortalCallbacks, ChargebeeInstance, Layout } from '@/services/chargebee/types';
import { getChargeBeeInstance } from '@/services/chargebee';
import { canSelfServeSubscription, chargebeeSubscription } from '@/ui/auth/auth';
import { t } from '@/ui/i18n/i18n';
import { SeatsCount } from '@/ui/pages/subscription/Chargebee/details/SeatsCount';
import { BillingAddress } from '@/ui/pages/subscription/Chargebee/details/BillingAddress';
import { PaymentDetails } from '@/ui/pages/subscription/Chargebee/details/PaymentDetails';
import { Invoices } from '@/ui/pages/subscription/Chargebee/details/Invoices';
import { useTask } from '@/ui/concerns';
import { createPortal } from '@/services/api/resources/chargebee/product/actions';
import CancelSubscription from '@/ui/components/subscription/CancelSubscription.vue';
import AiCredits from '@/ui/components/subscription/AiCredits.vue';
import BillingFrequency from '@/ui/pages/subscription/Chargebee/details/BillingFrequency.vue';
import { isAiPricingEnabled } from '@/ui/helpers/featureHelper';

export const Subscriptions = defineComponent({
  name: 'Subscriptions',
  setup() {
    const portal = ref();
    const chargebeePromise = ref<Promise<ChargebeeInstance | null>>();

    const openPortal = (sectionType: string, callbacks: PortalCallbacks) => {
      if (!portal.value) {
        return;
      }

      portal.value.openSection({
        sectionType,
        layout: Layout.IN_APP,
        params: { subscriptionId: chargebeeSubscription.value.id },
      }, { ...callbacks });
    };

    const createPortalTask = useTask(
      () => createPortal(),
      async response => {
        const chargebee = await chargebeePromise.value;
        chargebee.setPortalSession(async () => response.parsed);
        portal.value = chargebee.createChargebeePortal();
      },
    );

    onMounted(() => {
      chargebeePromise.value = getChargeBeeInstance();
    });

    return function render() {
      return container([
        container([
          pageTitle(t('common.subscriptions')),
          loader('div', createPortalTask, [
            canSelfServeSubscription.value
              ? [
                h(SeatsCount),
                h(BillingFrequency),
              ]
              : h(ManageYourPlan),
            h(BillingAddress, { on: { click: e => openPortal(e.sectionType, e.callbacks) } }),
            h(PaymentDetails, { on: { click: e => openPortal(e.sectionType, e.callbacks) } }),
            h(Invoices, { on: { click: e => openPortal(e.sectionType, e.callbacks) } }),
            isAiPricingEnabled() ? h(AiCredits) : null,
            h(CancelSubscription),
          ]),
        ]),
      ], 'narrow', 'subscription-details');
    };
  },
});
